<template>
  <div>
    <link itemprop="url" rel="stylesheet" href="css/restaurants.css"/>
    <HeaderOfPage
    :bgSrc          ="'banner-restaurant.jpg'"
    :titleOfPage    ="'المطاعم'"
    :theDiscription ="'موقع أجـــازة بــوك هو بوابتك المميزة للسفر في أي مكان داخل أو خارج جمهورية مصر العربية لو حابب تسافر وتتعرف علي كل أماكن العالم السياحية ، وتستمتع بكل شبر داخل وخارج مصر وتعيش المغامرة مع اصحابك وتتفسح مع عيلتك، تقدر تتصفح أجـــازة بــوك وتختار عايز تسافر فين وأمتي وبكـــام. أما بالنسبة لمستخدمي الموقع من شركات السياحة – شركاؤنا الكرام – يمكنكم عمل عروض تسويقية لكلاً من البرامج والفنادق وكمان متاح خاصية انك تعرض برامج او فنادق للبيع والشراء. بإختصار مع أجــازة بــوك '"
    />
    <section class="pages-container">
      <RestaurantContent/>
    </section>
  </div>
</template>
<script type="text/javascript">
  import HeaderOfPage      from '../global/HeaderOfPage'
  import RestaurantContent from './RestaurantContent'
  export default {
    name:'Restaurants',
    components:{HeaderOfPage, RestaurantContent},
    data() {
      return {

      }
    }
  }
</script>
